import React from 'react';
import { View, StyleSheet } from 'react-native';
import InputDateField, {
  DATE_PICKER,
} from 'common/components/InputDateField/InputDateField';
import Modal from 'common/components/Modal/Modal';
import { DRNInputField, DRNButton, DRNCardView } from '@traveloka/district-ui';

import R from 'common/res/R';
import BusTransactionFilterAgentContainer from '../containers/BusTransactionListFilterAgentContainer';
import AuthorizeView from 'common/components/AuthorizeView/AuthorizeView';
import TouchableInputFieldWrapper from 'common/components/TouchableInputFieldWrapper/TouchableInputFieldWrapper';
import convertDateToMDY from 'common/utils/date/convertDateToMDY';
import { BOOK_ON_BEHALF_PERMISSION } from 'common/constants/authPermissionConstants';

const now = new Date();
const sixtyDaysBeforeNow = new Date();
sixtyDaysBeforeNow.setDate(sixtyDaysBeforeNow.getDate() - 60);

class BusTransactionListFilter extends React.PureComponent {
  state = {
    openAgentAutocomplete: false,
  };
  constructor(props) {
    super(props);

    this.handleChangeStartDate = this.handleChangeStartDate.bind(this);
    this.handleChangeEndDate = this.handleChangeEndDate.bind(this);
    this.handleOpenAgentAutocomplete = this.handleOpenAgentAutocomplete.bind(
      this
    );
    this.handleCloseAgentAutocomplete = this.handleCloseAgentAutocomplete.bind(
      this
    );
    this.handleSelectAgent = this.handleSelectAgent.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleApplyFilter = this.handleApplyFilter.bind(this);
  }

  componentWillUnmount() {
    this.props.onResetFilters();
  }

  handleChangeStartDate(value) {
    this.setState({ startDateString: value, startDate: new Date(value) });
  }

  handleChangeEndDate(value) {
    this.setState({ endDateString: value, endDate: new Date(value) });
  }

  handleOpenAgentAutocomplete() {
    this.setState({ openAgentAutocomplete: true });
  }

  handleCloseAgentAutocomplete() {
    this.setState({ openAgentAutocomplete: false });
  }

  handleSelectAgent(selectedAgentId, selectedAgentName) {
    this.setState({ selectedAgentId, selectedAgentName });
  }

  handleApplyFilter() {
    this.props.onApplyFilter(
      this.state.selectedAgentId,
      this.state.startDate && convertDateToMDY(this.state.startDate),
      this.state.endDate && convertDateToMDY(this.state.endDate)
    );
  }

  handleReset() {
    this.setState(
      {
        selectedAgentId: undefined,
        selectedAgentName: undefined,
        startDate: undefined,
        endDate: undefined,
        startDateString: undefined,
        endDateString: undefined,
      },
      () => {
        this.props.onApplyFilter();
      }
    );
  }

  render() {
    const {
      startDateString,
      endDateString,
      selectedAgentName,
      openAgentAutocomplete,
    } = this.state;

    const isButtonDisabled =
      (this.state.startDate && !this.state.endDate) ||
      (!this.state.startDate && this.state.endDate);

    return (
      <DRNCardView style={styles.transactionFilterContainer}>
        <AuthorizeView.RequiredAll
          requiredPermission={[BOOK_ON_BEHALF_PERMISSION]}
        >
          <TouchableInputFieldWrapper
            onPress={this.handleOpenAgentAutocomplete}
          >
            <DRNInputField
              label={'Pilih Agen'}
              value={selectedAgentName || 'Semua Agen'}
              style={styles.bookOnBehalfInput}
              editable={false}
            />
          </TouchableInputFieldWrapper>

          <Modal isVisible={openAgentAutocomplete} style={{ margin: 0 }}>
            <BusTransactionFilterAgentContainer
              onSelectAgent={this.handleSelectAgent}
              onClose={this.handleCloseAgentAutocomplete}
            />
          </Modal>
        </AuthorizeView.RequiredAll>

        <View style={styles.filterListContainer}>
          <View style={styles.inputDateFieldContainer}>
            <InputDateField
              label="Dari"
              mode={DATE_PICKER}
              onDateChange={this.handleChangeStartDate}
              value={startDateString || ''}
              minimumDate={sixtyDaysBeforeNow}
              maximumDate={this.state.endDate || now}
              hideDefaultValue
            />
          </View>
          <View style={styles.inputDateFieldContainer}>
            <InputDateField
              label="Hingga"
              mode={DATE_PICKER}
              onDateChange={this.handleChangeEndDate}
              value={endDateString || ''}
              minimumDate={this.state.startDate || sixtyDaysBeforeNow}
              maximumDate={now}
              hideDefaultValue
            />
          </View>
        </View>
        <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
          <DRNButton
            buttonStyle={R.style.buttonBrandSecondary}
            text={'Hapus Tanggal'}
            onPress={this.handleReset}
            size={DRNButton.SIZE.SMALL}
          />
          <View style={{ flex: 1, marginLeft: R.spacing.xs }}>
            <DRNButton
              buttonStyle={R.style.buttonMainCta}
              text={'Cari'}
              onPress={this.handleApplyFilter}
              size={DRNButton.SIZE.SMALL}
              disabled={isButtonDisabled}
            />
          </View>
        </View>
      </DRNCardView>
    );
  }
}

export default BusTransactionListFilter;

const styles = StyleSheet.create({
  title: {
    ...R.typography.weightMedium,
    fontSize: R.typography.fontSize.medium,
    lineHeight: R.typography.fontSize.medium,
    marginTop: R.spacing.s,
    marginBottom: R.spacing.s,
  },
  transactionFilterContainer: {
    marginHorizontal: R.spacing.m,
    marginBottom: R.spacing.m,
    padding: R.spacing.m,
  },
  filterListContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  inputDateFieldContainer: {
    flex: 1,
  },
  inputDateFieldDivider: {
    paddingTop: R.spacing.xl,
  },
});
